import React from 'react'
import { Container } from 'semantic-ui-react'

const NotFound = () => {
  return <Container>Trang này không tồn tại.</Container>
}

export default NotFound
